import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';

import * as homeActions from '../actions';
import { HomeService } from '../../home.service';

@Injectable()
export class HomeEffects {
  private actions$ = inject(Actions);
  private homeService = inject(HomeService);
  constructor() {}

 /* This function is intentionally kept here; it is not used in the current implementation.

  getAllPress$ = createEffect(() =>
    this.actions$.pipe(
      ofType(homeActions.getAllPress),
      switchMap((action) =>
        this.homeService.getAllPress().pipe(
          map((response) =>
            homeActions.getAllPressSuccess({ data: response?.results })
          ),
          catchError((error: any) => of(homeActions.getAllPressFailure(error)))
        )
      )
    )
  );

  getAllFooterLinks$ = createEffect(() =>
    this.actions$.pipe(
      ofType(homeActions.getAllFooterLinks),
      switchMap((action) =>
        this.homeService.getAllCtaFooterLinks().pipe(
          map((response) =>
            homeActions.getAllFooterLinksSuccess({ data: response })
          ),
          catchError((error: any) =>
            of(homeActions.getAllFooterLinksFailure(error))
          )
        )
      )
    )
  );

  getAllQuickLinks$ = createEffect(() =>
    this.actions$.pipe(
      ofType(homeActions.getAllQuickLinks),
      switchMap((action) =>
        this.homeService.getAllQuickLinks().pipe(
          map((response) =>
            homeActions.getAllQuickLinksSuccess({ data: response })
          ),
          catchError((error: any) =>
            of(homeActions.getAllQuickLinksFailure(error))
          )
        )
      )
    )
  ); */

  getAllSiteSettings$ = createEffect(() =>
    this.actions$.pipe(
      ofType(homeActions.getAllSiteSettings),
      switchMap((action) =>
        this.homeService.getAllSiteSettings().pipe(
          map((response) =>
            homeActions.getAllSiteSettingsSuccess({ data: response })
          ),
          catchError((error: any) =>
            of(homeActions.getAllSiteSettingsFailure(error))
          )
        )
      )
    )
  );

  getAllHeroBanners$ = createEffect(() =>
    this.actions$.pipe(
      ofType(homeActions.getAllHeroBanners),
      switchMap((action) =>
        this.homeService.getAllHeroBanners().pipe(
          map((response) =>
            homeActions.getAllHeroBannersSuccess({ data: response })
          ),
          catchError((error: any) =>
            of(homeActions.getAllHeroBannersFailure(error))
          )
        )
      )
    )
  );
  getAllMegaMenu$ = createEffect(() =>
    this.actions$.pipe(
      ofType(homeActions.getAllMegaMenu),
      switchMap((action) =>
        this.homeService.getAllMegaMenu().pipe(
          map((response) =>
            homeActions.getAllMegaMenuSuccess({ data: response })
          ),
          catchError((error: any) =>
            of(homeActions.getAllMegaMenuFailure(error))
          )
        )
      )
    )
  );

 /* This function is intentionally kept here; it is not used in the current implementation.

  getAllPackageThemes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(homeActions.getAllPackageThemes),
      switchMap((action) =>
        this.homeService.getAllPackageThemes().pipe(
          map((response) =>
            homeActions.getAllPackageThemesSuccess({ data: response })
          ),
          catchError((error: any) =>
            of(homeActions.getAllPackageThemesFailure(error))
          )
        )
      )
    )
  );


  getAllPackageCategory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(homeActions.getPackageCategory),
      switchMap((action) =>
        this.homeService.getAllPackageCategory().pipe(
          map((response) =>
            homeActions.getPackageCategorySuccess({ data: response })
          ),
          catchError((error: any) =>
            of(homeActions.getPackageCategoryFailure(error))
          )
        )
      )
    )
  );

  getAllBlogCategories$ = createEffect(() =>
    this.actions$.pipe(
      ofType(homeActions.getAllBlogCategories),
      switchMap((action) =>
        this.homeService.getAllBlogCategories().pipe(
          map((response) =>
            homeActions.getAllBlogCategoriesSuccess({ data: response })
          ),
          catchError((error: any) =>
            of(homeActions.getAllBlogCategoriesFailure(error))
          )
        )
      )
    )
  ); */

  getExclusiveDeals$ = createEffect(() =>
    this.actions$.pipe(
      ofType(homeActions.getExclusiveDeals),
      switchMap((action) => {
        const queryParams = {
          isDomestic: action.data.isDomestic,
        };

        return this.homeService.getExclusiveDeals(queryParams).pipe(
          map((response) =>
            homeActions.getExclusiveDealsSuccess({ data: response })
          ),
          catchError((error: any) =>
            of(homeActions.getExclusiveDealsFailure({ error }))
          )
        );
      })
    )
  );

  getTravellerStories$ = createEffect(() =>
    this.actions$.pipe(
      ofType(homeActions.getTravellerStories),
      switchMap((action) => {
        const queryParams = {
          isDomestic: action.data.isDomestic,
        };

        // Return the observable here to properly chain it
        return this.homeService.getTravellerStories(queryParams).pipe(
          map((response) =>
            homeActions.getTravellerStoriesSuccess({ data: response })
          ),
          catchError((error) =>
            of(homeActions.getTravellerStoriesFailure({ error }))
          )
        );
      })
    )
  );

  getAllExplorePackages$ = createEffect(() =>
    this.actions$.pipe(
      ofType(homeActions.getAllExplorePackages),
      switchMap((action) =>
        this.homeService.getExplorePackages().pipe(
          map((response) =>
            homeActions.getAllExplorePackagesSuccess({ data: response })
          ),
          catchError((error: any) =>
            of(homeActions.getAllExplorePackagesFailure(error))
          )
        )
      )
    )
  );

  getAllBlogPost$ = createEffect(() =>
    this.actions$.pipe(
      ofType(homeActions.getAllBlogPost),
      switchMap((action) =>
        this.homeService.getBlogPost().pipe(
          map((response) =>
            homeActions.getAllBlogPostSuccess({ data: response })
          ),
          catchError((error: any) =>
            of(homeActions.getAllBlogPostFailure(error))
          )
        )
      )
    )
  );
}
